import axios from "axios";
import moment from "moment";
import Swal from "sweetalert2";
import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    redirectview: "",
    serverUrl: "https://communitybotbyzwizai.herokuapp.com/",
    query: {},
    branch: [],
    branchloading: false,
    rewardcategory: [],
    rewards: [],
    profile: {},
    address: [],
    subbranch: [],
    input: {
      firstName: "",
      lastName: "",
      phoneNumber: "",
      email: "",
      dob: "", // YYYY-MM-DD
      job: "",
      identityNumber: "",
      identityNumberImage: "", // url รูปบัตรที่อัปโหลด
      password: "",
      departmentStore: "",
      branch: "",
      otp: "",
    },
    selectedReward: {},
    member: {},
    currentOtpRef: "",
    testPageid: ["108537541446937"],
    checkPdpaStatus: null,
    isCancelPdpa: false,
    cachesImageUrl: "",
    cachesReferral: "",
  },
  mutations: {},
  actions: {
    getSubBranch({ state }, department_store) {
      return new Promise((resolve) => {
        state.branchloading = true;
        axios
          .get(state.serverUrl + "toacrm/sub-branchs", {
            params: {
              department_store,
            },
            headers: {
              AUTHORIZATION: "Bearer xxx xxx",
            },
          })
          .then(async (response) => {
            state.branchloading = false;
            if (response.data.responsecode == 200) {
              resolve(response.data.data.map((el) => el.branch));
              return;
            } else {
              await Swal.fire({
                text: response.data.reason,
              });

              window.liff.closeWindow();
              resolve();
            }
          });
      });
    },
    isOTPready() {
      return new Promise((resolve) => {
        var cooldowntime = 3; /* minutes */

        if (localStorage.getItem("otp_cd")) {
          var time = localStorage.getItem("otp_cd");
          var duration = moment.duration(moment().diff(time));
          var difftime = duration.asMinutes();

          if (difftime >= cooldowntime) {
            var newtime = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
            var newduration = moment.duration(moment().diff(newtime));
            var newdifftime = newduration.asMinutes();
            localStorage.setItem("otp_cd", newtime);
            resolve({ status: true, timeleft: cooldowntime - newdifftime });
          } else {
            resolve({ status: false, timeleft: cooldowntime - difftime });
          }
        } else {
          var time = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
          var duration = moment.duration(moment().diff(time));
          var difftime = duration.asMinutes();
          localStorage.setItem("otp_cd", time);
          resolve({ status: true, timeleft: cooldowntime - difftime });
        }
      });
    },
    sendMessage({ state }, message) {
      var vm = this;
      return new Promise(async (resolve) => {
        var url = state.serverUrl + "zwiz-pushmsg-webbrowser";
        var data = {
          // pageid: state.query.pageid,
          pageid: state.pageid || state.query.pageid,
          userid: state.userid,
          message,
        };
        if (await window.liff.isInClient()) {
          try {
            await window.liff.sendMessages([
              {
                text: message,
                type: "text",
              },
            ]);
            resolve();
          } catch (error) {
            alert(JSON.stringify(error));
            alert(JSON.stringify(error.message));
          }
        } else {
          axios
            .post(url, data, {
              headers: {
                AUTHORIZATION: "Bearer xxx xxx",
              },
            })
            .then(async (response) => {
              if (response.data.responsecode == 200) {
                resolve();
              } else {
                if (response.data.reason) {
                  await Swal.fire({
                    text: response.data.reason,
                  });
                  resolve();
                }
              }
            });
        }
      });
    },
    messengerClose() {
      MessengerExtensions.requestCloseBrowser(
        function success() {},
        function error() {
          window.close();
        }
      );
    },
  },
  modules: {},
});
